var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFerrariBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2400,
    height: 384,
    viewBox: "0 0 2400 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_2161)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_34_2161)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_2161",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_2161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.5879 687.54L777.159 58.466H1268.83L300.33 819.329L-23.5879 818.53V687.54Z",
    fill: "url(#paint0_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.121 625.24H777.566L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5874 513.738L368.856 205.431H748.286L-27.8574 815.176L-23.5874 513.738Z",
    fill: "url(#paint2_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.018 -12.939L160.941 435.703H592.121L1165.49 -14.736L732.018 -12.939Z",
    fill: "url(#paint3_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.5928 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint4_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.799 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.799 -10.224Z",
    fill: "url(#paint5_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.622L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint6_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.8955 412.49H280.975L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint7_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.77 -14.736L1003.48 334.305H1574.65L2000.11 0.0600386L1447.77 -14.736Z",
    fill: "url(#paint8_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 -12.141L1719.43 535.463H1268.83L1961.1 -8.38699L2416.47 -12.141Z",
    fill: "url(#paint9_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.622 815.176L1425.37 184.527H1883.73L1078.93 816.784L622.622 815.176Z",
    fill: "url(#paint10_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 105.102L2086.23 364.547H1649.48L2126.82 -10.455H2416.47V105.102Z",
    fill: "url(#paint11_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.6 -10.455L1381.28 292.257H1903.25L2291.07 -12.418L1766.6 -10.455Z",
    fill: "url(#paint12_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.63 480.511H888.183L1524.97 -19.756H2000.11L1317.63 480.511Z",
    fill: "url(#paint13_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368.49 -10.455L1771.8 458.305H2248.11L2411.21 330.171L2416.47 -10.455H2368.49Z",
    fill: "url(#paint14_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413.84 159.784L1773.5 662.843H2111.47L2409.3 428.866L2413.84 159.784Z",
    fill: "url(#paint15_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.85 -19.756L691.791 262.326H1158.22L1521.13 -22.778L1050.85 -19.756Z",
    fill: "url(#paint16_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5873 369.04H422.944L-34.4473 728.37L-23.5873 369.04Z",
    fill: "url(#paint17_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.88 -10.455L1086.33 293.221H735.271L1115.67 -5.62596L1472.88 -10.455Z",
    fill: "url(#paint18_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.7305 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint19_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.943 -121.136L-153.013 331.34V-118.652L422.943 -121.136Z",
    fill: "url(#paint20_linear_34_2161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.6 636.923H1589.9L2469.95 -40.036H2794.4L1917.6 636.923Z",
    fill: "url(#paint21_linear_34_2161)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#A51E22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.624 214C113.06 214 105.256 206.896 105 193.84H116.45C117.154 201.456 122.015 205.68 137.751 205.68C152.144 205.68 157.581 201.776 157.581 195.952C157.581 189.744 154.127 187.632 136.28 185.968C112.356 183.6 106.407 178.864 106.407 167.856C106.407 156.848 115.938 149.936 135.001 149.936C155.598 149.936 165.322 155.376 165.705 168.112H154.127C153.552 161.456 148.306 158.512 135.257 158.512C123.039 158.512 117.346 161.2 117.346 166.832C117.346 172.464 120.736 174.704 138.903 176.496C162.187 178.864 168.84 182.704 168.84 194.8C168.84 206.896 158.477 213.936 137.688 213.936L137.624 214Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.507 189.424H253.277C253.085 205.808 239.46 214 218.543 214C194.747 214 181.569 202.8 181.569 181.168C181.569 161.776 194.875 150 217.839 150C240.803 150 252.19 159.152 252.638 174.192H240.676C240.228 163.824 231.912 159.152 218.159 159.152C202.231 159.152 193.915 166.448 193.915 181.296C193.915 197.488 202.295 204.656 218.735 204.656C231.912 204.656 241.187 199.728 241.443 189.424H241.507Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332.664 150.576V187.312C332.664 205.168 323.645 213.552 300.36 213.552C278.291 213.552 268.696 205.68 268.696 188.08V150.576H280.466V187.056C280.466 199.088 285.84 204.4 300.552 204.4C315.265 204.4 320.894 199.28 320.894 186.096V150.576H332.664Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.578 150.96C407.502 150.96 418.12 162.544 418.12 181.36C418.12 200.176 407.757 213.04 384.153 213.04H352.233V150.96H383.578ZM364.003 204.08H382.938C399.314 204.08 405.902 196.464 405.902 181.744C405.902 167.024 399.506 159.984 381.659 159.984H364.003V204.08Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M491.108 150.96V159.472H446.842V177.392H480.17V185.712H446.842V204.592H491.108V213.104H435.072V151.024H491.108V150.96Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M555.973 182.448V183.344C563.074 184.112 567.935 188.08 567.935 194.672V213.104H556.421V194.736C556.421 188.528 550.216 186.416 545.675 186.416H518.936V213.104H507.166V151.024H547.658C562.626 151.024 569.279 157.424 569.279 167.216C569.279 177.008 563.138 180.976 555.973 182.448ZM518.936 178.224H545.675C553.543 178.224 557.892 175.216 557.892 168.24C557.892 162.864 554.246 159.344 546.442 159.344H518.936V178.224Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M598.448 150.96V213.04H586.678V150.96H598.448Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M656.978 150.96L688.386 210.48V213.104H676.872L669.707 199.024H628.96L621.795 213.104H610.793V210.48L642.393 150.96H657.042H656.978ZM649.238 158.768L633.246 190.384H665.357L649.238 158.768Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M781.075 150.96V159.472H737.513V181.36H771.544V189.744H737.513V213.04H725.743V150.96H781.075Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M851.44 150.96V159.472H807.174V177.392H840.502V185.712H807.174V204.592H851.44V213.104H795.404V151.024H851.44V150.96Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M916.301 182.448V183.344C923.401 184.112 928.263 188.08 928.263 194.672V213.104H916.748V194.736C916.748 188.528 910.543 186.416 906.002 186.416H879.263V213.104H867.493V151.024H907.985C922.953 151.024 929.606 157.424 929.606 167.216C929.606 177.008 923.465 180.976 916.301 182.448ZM879.263 178.224H906.002C913.87 178.224 918.22 175.216 918.22 168.24C918.22 162.864 914.573 159.344 906.769 159.344H879.263V178.224Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M995.815 182.448V183.344C1002.92 184.112 1007.78 188.08 1007.78 194.672V213.104H996.263V194.736C996.263 188.528 989.994 186.416 985.516 186.416H958.778V213.104H947.008V151.024H987.499C1002.47 151.024 1009.12 157.424 1009.12 167.216C1009.12 177.008 1002.98 180.976 995.815 182.448ZM958.778 178.224H985.516C993.384 178.224 997.734 175.216 997.734 168.24C997.734 162.864 994.088 159.344 986.284 159.344H958.778V178.224Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.71 150.96L1096.12 210.48V213.104H1084.6L1077.44 199.024H1036.69L1029.53 213.104H1018.52V210.48L1050.12 150.96H1064.77H1064.71ZM1057.03 158.768L1041.04 190.384H1073.15L1057.03 158.768Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.53 182.448V183.344C1164.63 184.112 1169.49 188.08 1169.49 194.672V213.104H1157.97V194.736C1157.97 188.528 1151.77 186.416 1147.23 186.416H1120.49V213.104H1108.72V151.024H1149.21C1164.18 151.024 1170.83 157.424 1170.83 167.216C1170.83 177.008 1164.69 180.976 1157.46 182.448H1157.53ZM1120.49 178.224H1147.23C1155.1 178.224 1159.45 175.216 1159.45 168.24C1159.45 162.864 1155.8 159.344 1148 159.344H1120.49V178.224Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 150.96V213.04H1188.23V150.96H1200Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_2161",
    x1: 900.322,
    y1: 136.714,
    x2: 220.424,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_2161",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.392,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_2161",
    x1: 64.8374,
    y1: 608.483,
    x2: 513.998,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34_2161",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34_2161",
    x1: 200.655,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34_2161",
    x1: -97.0268,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34_2161",
    x1: -214.998,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34_2161",
    x1: 20.1713,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34_2161",
    x1: 1141.98,
    y1: 436.034,
    x2: 1485.93,
    y2: 178.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34_2161",
    x1: 1393.44,
    y1: 597.841,
    x2: 1823.09,
    y2: 276.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34_2161",
    x1: 753.282,
    y1: 873.897,
    x2: 1231.38,
    y2: 516.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34_2161",
    x1: 1757.18,
    y1: 438.419,
    x2: 2046.19,
    y2: 222.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34_2161",
    x1: 1507.99,
    y1: 385.507,
    x2: 1821.88,
    y2: 150.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34_2161",
    x1: 1427.62,
    y1: 156.66,
    x2: 1485.59,
    y2: 415.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34_2161",
    x1: 2089.36,
    y1: 202.623,
    x2: 2145.8,
    y2: 454.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34_2161",
    x1: 2283.7,
    y1: 204.309,
    x2: 2095.62,
    y2: 538.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34_2161",
    x1: 1096.28,
    y1: 74.3578,
    x2: 1135.39,
    y2: 248.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34_2161",
    x1: -34.4471,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34_2161",
    x1: 1037.07,
    y1: 246.023,
    x2: 1251.65,
    y2: -89.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_34_2161",
    x1: -52.7469,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_34_2161",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3131,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_34_2161",
    x1: 2295.31,
    y1: 168.921,
    x2: 2039.11,
    y2: 490.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_2161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_34_2161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerrariBanner);
export default __webpack_public_path__ + "static/media/ferrari_banner.8bd647a558d08a4b78b6438520fc916a.svg";
export { ForwardRef as ReactComponent };